export const TAG_DOCUMENT = 'Document' as const;
export const TAG_IMPORT_JOB = 'ImportJob' as const;
export const TAG_LABEL = 'Label' as const;
export const TAG_COURT = 'Court' as const;
export const TAG_PORTAL_CREDENTIAL = 'PortalCredential' as const;
export const TAG_CUSTOMER = 'Customer' as const;
export const TAG_SPRAWA = 'Sprawa' as const;
export const TAG_POSIEDZENIE = 'Posiedzenie' as const;
export const TAG_SPRAWA_STATUS_DEFINITION = 'SprawaStatusDefinition' as const;
export const TAG_PELNOMOCNIK = 'Pelnomocnik' as const;
export const TAG_TIME_ENTRY = 'TimeEntry' as const;
export const TAG_TENANT = 'Tenant' as const;
export const TAG_ORG_MEMBER = 'OrgMember' as const;
export const TAG_CUSTOMER_UPLOAD_LINK = 'CustomerUploadLink' as const;
export const TAG_LEGAL_PROFESSIONAL = 'LegalProfessional' as const;
export const TAG_BILLING = 'Billing' as const;
